<div class="maintenance-page" role="status" aria-live="polite">
  <div class="gradient-background-mobile">
    <div class="gradient-ellipse ellipse-1"></div>
    <div class="gradient-ellipse ellipse-2"></div>
    <div class="gradient-ellipse ellipse-3"></div>
  </div>

  <div class="gradient-background-desktop">
    <div class="gradient-ellipse-desktop ellipse-desktop-1"></div>
    <div class="gradient-ellipse-desktop ellipse-desktop-2"></div>
    <div class="gradient-ellipse-desktop ellipse-desktop-3"></div>
    <div class="gradient-ellipse-desktop ellipse-desktop-4"></div>
    <div class="gradient-ellipse-desktop ellipse-desktop-5"></div>
    <div class="gradient-ellipse-desktop ellipse-desktop-6"></div>
  </div>

  <div class="maintenance-card">
    <img class="brand-logo" src="/assets/images/Logo.png" alt="McCain Logo" width="180" height="auto" />
    <div class="product-title">DIGITAL PASSPORT</div>
    <h1 class="headline">{{ systemStatus.status().title }}</h1>
    <p class="body-text">{{ systemStatus.status().message }}</p>
    <p class="kind-badge" *ngIf="systemStatus.status().kind === outageKind">Service disruption</p>
    <a
      *ngIf="hasSafeDetailUrl()"
      class="detail-link"
      [href]="safeDetailUrl()"
      rel="noopener noreferrer"
      target="_blank"
    >
      More information
    </a>
    <p class="retry-hint" *ngIf="systemStatus.status().retryAfterMinutes">
      We expect to restore service within about {{ systemStatus.status().retryAfterMinutes }} minutes. This page
      checks for updates automatically.
    </p>
    <p class="updated-at" *ngIf="systemStatus.status().updatedAt">Last updated: {{ systemStatus.status().updatedAt }}</p>
    <button type="button" class="retry-button" (click)="onTryAgain()">Check again</button>
  </div>
</div>
